import "./AboutContentStyles.css"
import react1 from "../pictures/react1.jpg"
import react2 from "../pictures/react2.jpg"

import React from "react";
import { Link } from "react-router-dom";

const AboutContent = () => {
  return (
    <div className="about">
      <div className="left">
        <h1>Who am I ?</h1>
        <p>
        I’m a Frontend Developer specializing in React.js and Next.js, creating responsive, animated, and visually engaging websites with Tailwind/Bootstrap and API integrations — with growing expertise in full-stack development.
        </p>
        <Link to="/contact">
           <button  className="btn">Contact</button>
        </Link> 
      </div>
      <div className="right">
        <div className="image-container">
            <div className="image-stack top">
                <img src={react1} className="img" alt="react1" />
            </div>
            <div className="image-stack bottom">
                <img src={react2} className="img" alt="react2" />
            </div>
        </div>
      </div>
    </div>
  );
};

export default AboutContent;
